import { Form, Modal } from "react-bootstrap";
import Moment from "react-moment";
const SessionInformation = ({ show, hide, title, inboxData }) => {
  const InfoRow = ({ label, value }) => (
    <div className="hstack justify-content-between py-1">
      <span className="text-muted">{label}</span>
      <span className="fw-medium text-end">{value || "-"}</span>
    </div>
  );;

  const getLocation = (deviceInfo) => {
    const parts = [
      deviceInfo?.city || "",
      deviceInfo?.regionName || "",
      deviceInfo?.country || "",
      deviceInfo?.zip || "",
    ]
      .map(v => v?.toString().trim())
      .filter(v => v);
    return parts.length ? parts.join(", ") : "_";
  };

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton className="p-3">
        <Modal.Title style={{ fontSize: 15 }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="preview-scroll p-0">
          <Form.Label>Additional Info</Form.Label>
          <InfoRow label="Created Date | Time"
            value={
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxData?.createdAt}
              </Moment>
            }
          />
          <InfoRow label="Updated Date | Time"
            value={
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxData?.updatedAt}
              </Moment>
            }
          />
          <InfoRow label="First Seen Date | Time"
            value={
              inboxData?.startedDT ?
                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                  {inboxData?.startedDT}
                </Moment>
                : ""
            }
          />
          <InfoRow label="Last Seen Date | Time"
            value={
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxData?.endedDT || inboxData?.lastActivityDT}
              </Moment>
            }
          />
          <hr />
          <Form.Label>Location Info</Form.Label>
          <InfoRow label="Ip Address" value={inboxData?.deviceInfo?.ipAddress} />
          <InfoRow label="Country" value={getLocation(inboxData?.deviceInfo?.country)} />
          <InfoRow label="City" value={getLocation(inboxData?.deviceInfo?.city)} />
          <InfoRow label="Region" value={getLocation(inboxData?.deviceInfo?.regionName)} />
          <InfoRow label="Zip Code" value={getLocation(inboxData?.deviceInfo?.zip)} />
          <InfoRow label="Timezone" value={inboxData?.deviceInfo?.timezone} />
          <hr />
          <Form.Label>Device Info</Form.Label>
          <InfoRow label="Browser Name" value={inboxData?.deviceInfo?.browser?.name} />
          <InfoRow label="Browser Version" value={inboxData?.deviceInfo?.browser?.version} />
          <InfoRow label="OS Name" value={inboxData?.deviceInfo?.os?.name} />
          <InfoRow label="OS Version" value={inboxData?.deviceInfo?.os?.version} />
          <InfoRow label="Device" value={inboxData?.deviceInfo?.device?.type} />
          <hr />
          <Form.Label>Web Session</Form.Label>
          <InfoRow label="First Session"
            value={
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxData?.createdAt}
              </Moment>
            }
          />
          <InfoRow label="Latest Session"
            value={
              <Moment format="DD MMM YYYY | HH:mm" withTitle>
                {inboxData?.endedDT || inboxData?.lastActivityDT}
              </Moment>
            }
          />
          <InfoRow label="Total Session" value={inboxData?.totalSession} />
          <InfoRow label="Page View" value={inboxData?.allPageView} />
          <InfoRow label="Time Spent" value={`2h`} />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SessionInformation;
